var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejectionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.73047,
    y: 6.22949,
    width: 67.4595,
    height: 67.4595,
    rx: 33.7297,
    fill: "#FEE4E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.73047,
    y: 6.22949,
    width: 67.4595,
    height: 67.4595,
    rx: 33.7297,
    stroke: "#FEF3F2",
    strokeWidth: 11.2432
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4603 34.3377V39.9593M39.4603 45.5809H39.4744M53.5144 39.9593C53.5144 47.7212 47.2221 54.0134 39.4603 54.0134C31.6985 54.0134 25.4062 47.7212 25.4062 39.9593C25.4062 32.1975 31.6985 25.9053 39.4603 25.9053C47.2221 25.9053 53.5144 32.1975 53.5144 39.9593Z",
    stroke: "#D92D20",
    strokeWidth: 2.81081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectionIcon);
export default __webpack_public_path__ + "static/media/rejectionIcon.8340d4c68feec4d12b2a9ec421d5deda.svg";
export { ForwardRef as ReactComponent };